import React from "react";
import CommonCourierServiceAction from "./CommonCourierServiceAction";

export default function EditCourierService() {
    return <CommonCourierServiceAction mode={"update"} />;
}
